import axios from "axios";
import { getHeaders } from "../utils/main";
import endpoints from "./endpoints";

export const FetchProductionPlanningApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.ProductionPlanningFetch,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};

export const createProductionPlanningApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.ProductionPlanningCreate,
    method: "post",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};

export const updateProductionPlanningApi = async (params, data) => {
  const callResponse = await axios({
    url: endpoints.ProductionPlanningUpdate,
    method: "patch",
    headers: getHeaders(),
    params,
    data,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};

export const ProductionPlanningStockOutApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.ProductionPlanningStockOut,
    method: "post",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};

export const DeleteProductionPlanningApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.ProductionPlanningDelete,
    method: "delete",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};

export const GetProductionPlanningByIdApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.ProductionPlanningFindById,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const FetchProductionPurchaseApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.FetchProductionPurchaseRequest,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};

export const FetchAvailableStockInAssemblyApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.FetchAvailableStockInAssembly,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const UpdateAssemblyFgStatus = async (params) => {
  const callResponse = await axios({
    url: endpoints.UpdateAssemblyFgStatus,
    method: "patch",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const CreateAssemblyStockOut = async (params) => {
  const callResponse = await axios({
    url: endpoints.CreateAssemblyStockOut,
    method: "post",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response.status,
    }));

  return callResponse;
};
